import React, {useState, useEffect, useContext, useRef} from 'react';
import axios from "../common/axios";
import {BrandContext} from "../common/BrandContext";
import {ContentContext} from "../common/ContentContext";
import CircularLoader from "../common/CircularLoader";

const AdminCMSContent = props => {
    const lessonUrl = '/administration/syllabus/manageSyllabus.action';
    const {content,updateCssStylesAndClasses} = useContext(ContentContext);
    const brandConfig = useContext(BrandContext);
    const [isLoading, setLoading] = useState(true);
    const [isError, setError] = useState(false);
    const [html, setHtml] = useState();
    const divRef = useRef();

    const loadCMSContent = () => {
        let conceptId = content.currentConcept !== undefined ? content.currentConcept.conceptId : null;
        setLoading(true);
        setHtml('');
        axios.get(lessonUrl, {params: {conceptId: conceptId, bodyOnly: true}})
            .then(response => {
                let html = response.data;
                setHtml(html);
                setLoading(false);
                setError(false);

                const state = {conceptId: conceptId, bodyOnly: true}
            }).catch(function (e) {
            console.error('Error loading content', e);
            setHtml('');
            setLoading(false);
            setError(true);

            if (typeof newrelic !== 'undefined') {
                newrelic.noticeError('Lesson error: ' + e);
            }
        });
    }

    useEffect(() => {
        if (content === undefined) {
            return;
        }

        if (divRef.current === undefined) {
            return;
        }

        try {
            updateCssStylesAndClasses(content);

            divRef.current.innerHTML = '';
            if (html != undefined) {
                const htmlFragment = document.createRange().createContextualFragment(html);
                divRef.current.appendChild(htmlFragment);
                $(divRef.current).reloadMathJax();
            }
        } catch (e) {
            console.error('Error loading content', e);
            if (typeof newrelic !== 'undefined') {
                newrelic.noticeError('Lesson error: ' + e);
            }
        }
    }, [html]);

    useEffect(() => {
        loadCMSContent();
    }, [content]);

    return (
        <>
            {isLoading && (
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <CircularLoader/>
                </div>
            )}
            {isError && (
                <div className="ch-content-error">There was an error loading your content. Reload&nbsp;<a className="ch-link" href="/web/ui/view/lastLesson">{brandConfig.conceptName.toLowerCase()}</a></div>
            )}
            <div className={'ch-lesson-content-cms'} ref={divRef}></div>
        </>
    );
}

export default AdminCMSContent;